import { render, staticRenderFns } from "./GoodsCellB.vue?vue&type=template&id=43bf4c8e&scoped=true&"
import script from "./GoodsCellB.vue?vue&type=script&lang=js&"
export * from "./GoodsCellB.vue?vue&type=script&lang=js&"
import style0 from "./GoodsCellB.vue?vue&type=style&index=0&id=43bf4c8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bf4c8e",
  null
  
)

export default component.exports